import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWeave = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.81978 2.4419C7.12804 2.48044 7.3467 2.76157 7.30817 3.06983L7.01221 5.43755H11.5041L11.3634 6.56255H3C2.68934 6.56255 2.4375 6.31071 2.4375 6.00005C2.4375 5.68939 2.68934 5.43755 3 5.43755H5.87845L6.19186 2.93029C6.23039 2.62203 6.51152 2.40337 6.81978 2.4419Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.69095 6.93755H6.82471L6.47314 9.75005H6.465L5.9025 14.25H5.91064L5.80817 15.0698C5.76964 15.3781 5.48851 15.5967 5.18024 15.5582C4.87198 15.5197 4.65332 15.2386 4.69186 14.9303L4.98783 12.5625H3C2.68934 12.5625 2.4375 12.3107 2.4375 12C2.4375 11.6894 2.68934 11.4375 3 11.4375H5.12845L5.69095 6.93755Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9878 12.5625H6.48844L6.62906 11.4375H15C15.3107 11.4375 15.5625 11.6894 15.5625 12C15.5625 12.3107 15.3107 12.5625 15 12.5625H12.1216L11.8082 15.0698C11.7696 15.3781 11.4885 15.5967 11.1802 15.5582C10.872 15.5197 10.6533 15.2386 10.6919 14.9303L10.9878 12.5625Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8716 6.56255L12.3091 11.0625H11.1753L12.1919 2.93029C12.2304 2.62203 12.5115 2.40337 12.8198 2.4419C13.128 2.48044 13.3467 2.76157 13.3082 3.06983L13.0122 5.43755H15C15.3107 5.43755 15.5625 5.68939 15.5625 6.00005C15.5625 6.31071 15.3107 6.56255 15 6.56255H12.8716Z",
			fill: "#33373D"
		})
	]
});
export { SvgIconWeave as ReactComponent };
